import React, { useState } from 'react'
import { Button } from '../../../components/common'
import Navigator from '../../../components/common/Navigator'
import { useFetchSchemes } from './api'

const Schemes = () => {
  const { data, isLoading, isError } = useFetchSchemes()
  const [selectedScheme, setSelectedScheme] = useState<any>(null)

  if (isLoading) {
    return (
      <div className="text-center mt-6 text-gray-500">Loading schemes...</div>
    )
  }

  if (isError || !data?.data) {
    return (
      <div className="text-center mt-6 text-red-500">
        Failed to load schemes.
      </div>
    )
  }
  const capitalizeFirstLetter = (text: string) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : ''
  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
      <Navigator title="Schemes" slug="SCHEMES" />
      <h1 className="font-barlow font-medium text-[40px] leading-[40px] tracking-normal text-black">
        Schemes
      </h1>
      <p className="font-barlow font-normal text-[15px] leading-[27px] tracking-normal text-gray-600 mt-1">
        Available Schemes and Benefits for Startups & MSMEs
      </p>
      <hr className="border-t-2 border-primaryBlue my-4" />

      <div className="flex flex-col">
        {data.data.map((item: any) => (
          <div
            key={item.id}
            className="border border-inputBg rounded-md p-5 lg:mb-4 shadow-[0_4px_6px_0_#FFDFB740] mt-6"
          >
            <span className="inline-block bg-LightPink text-black font-barlow font-semibold text-[14px] leading-[16px] tracking-normal px-4 py-2 rounded-full mb-3">
              {item.scheme_owner}
            </span>

            {/* <h2 className="font-barlow font-medium text-[19px] leading-[19px] tracking-normal text-black mb-2">
              {item.name}
            </h2>

            <p className="font-barlow font-light text-[12px] leading-[18px] tracking-normal text-gray-600 text-justify">
              {item.description}
            </p>
 */}
            <h2 className="font-barlow font-medium text-[19px] leading-[19px] tracking-normal text-black mb-2">
              {capitalizeFirstLetter(item.name)}
            </h2>

            <p className="font-barlow font-light text-[12px] leading-[18px] tracking-normal text-gray-600 text-justify">
              {capitalizeFirstLetter(item.description)}
            </p>
            <div className="mt-6">
              <Button
                label={'Read More'}
                size="common"
                outlined
                className="border border-LightGreen text-LightGreen px-8 py-3 hover:bg-LightGreen hover:text-white"
                onClick={() => setSelectedScheme(item)}
              />
            </div>
          </div>
        ))}
      </div>
      {selectedScheme && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg max-w-6xl w-full p-6 relative max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <div className="flex flex-col items-start">
                {/* <div className="flex gap-1 bg-gray-50 px-3 py-1 rounded-full text-xs justify-start mb-3">
                  <Icons name="watch" className="text-black" />
                  <p>{selectedAct?.readTime}</p>
                </div> */}

                <span className="text-gray-500 text-sm">
                  Posted On:
                  {new Date(selectedScheme?.created_at).toLocaleDateString(
                    'en-GB',
                    {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    }
                  )}
                </span>
              </div>
            </div>

            <h2 className="text-2xl font-bold mb-3">
              {capitalizeFirstLetter(selectedScheme?.name)}
            </h2>

            <div
              className="text-[15px] leading-7 text-gray-700 text-black bg-white text-justify"
              dangerouslySetInnerHTML={{
                __html: capitalizeFirstLetter(
                  selectedScheme?.description || ''
                ),
              }}
            />

            <div className="mt-4 flex justify-center gap-4">
              <Button
                outlined
                label="Visit"
                className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 hover:bg-PrimaryOrange hover:text-white min-w-[160px] text-[20px] align-middle"
                onClick={() => {
                  let url = selectedScheme?.link

                  if (url) {
                    url = url.replace(/\\\//g, '/')

                    url = url.replace(/^https?\/\//, (match: any) =>
                      match.replace('//', '://')
                    )

                    if (!/^https?:\/\//i.test(url)) {
                      url = 'https://' + url
                    }

                    window.open(url, '_blank', 'noopener,noreferrer')
                  }
                }}
              />
              <Button
                label="Close"
                redOutlined
                className="min-w-[160px] px-10"
                onClick={() => setSelectedScheme(null)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Schemes
